import { makeVar } from '@apollo/client';
import { OktaAuth } from '@okta/okta-auth-js';

export const isUserAuthenticated = makeVar(false);
export const authClientVar = makeVar({} as OktaAuth);
